angular.module('jv.Admin.Users')
    .controller('jvAdminUsersLandingController', ['$scope', 'breadcrumbsResolve', 'navInjectionSVC',
        function ($scope, breadcrumbsResolve, navInjectionSVC) {
            $scope.flags.loading = false;
            $scope.breadcrumbsConfig = breadcrumbsResolve;
            $scope.getNavigation = function() {
                navInjectionSVC.getUserNavigation(function(navItems) {
                    $scope.sections = navItems;
                });
            };
            $scope.getNavigation();
        }]);